import React, { useMemo } from 'react';

import { Filter } from '@gogame/filters';
import { dateFNS } from '@gogame/intl-ts';

import {
  FILTER_PERIOD,
  FILTER_APPLICATIONS,
  FILTER_AFFILIATES,
  FILTER_EVENTS,
  FILTER_DEPENDENCIES,
  PERIOD_PRESETS,
} from 'scenes/PostbacksReport/constants';
import {
  loadApplications,
  loadAffiliates,
  loadEvents,
} from 'scenes/PostbacksReport/sources/filters';

export const PeriodFilter = (props) => {
  const minDate = useMemo(() => {
    return dateFNS.startOfMonth(dateFNS.subDays(new Date(), 28));
  }, []);

  return (
    <Filter.DateRangePicker
      title={'Event period'}
      name={FILTER_PERIOD}
      presets={PERIOD_PRESETS}
      minDate={minDate}
      maxDate={new Date()}
      required={true}
      {...props}
    />
  );
};

export const ApplicationsFilter = (props) => {
  return (
    <Filter.MultiSelect
      name={FILTER_APPLICATIONS}
      title={'Applications'}
      source={loadApplications}
      withAll={false}
      placeholder={'Select applications'}
      required={true}
      {...props}
    />
  );
};

export const AffiliatesFilter = (props) => {
  return (
    <Filter.MultiSelect
      name={FILTER_AFFILIATES}
      title={'Affiliate'}
      source={loadAffiliates}
      depends={FILTER_DEPENDENCIES[FILTER_AFFILIATES]}
      withSelectAll={false}
      withAll={false}
      placeholder={'Select affiliates'}
      required={true}
      maxOptionsSelected={8}
      {...props}
    />
  );
};

export const EventsFilter = (props) => {
  return (
    <Filter.MultiSelect
      name={FILTER_EVENTS}
      title={'Events'}
      source={loadEvents}
      withAll={false}
      placeholder={'Select events'}
      required={true}
      {...props}
    />
  );
};

export default {
  Period: PeriodFilter,
  Applications: ApplicationsFilter,
  Affiliates: AffiliatesFilter,
  Events: EventsFilter,
};
